import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Os recados curtos de "deu certo" e "deu errado".
 *
 * Existe porque salvar sem retorno visível é a queixa mais comum de sistema
 * interno: a pessoa clica, nada muda na tela (o formulário já mostrava o valor
 * novo) e ela clica de novo, ou sai sem saber se gravou.
 *
 * Fica numa store e não em cada tela porque o recado precisa sobreviver à
 * navegação: salvar o fornecedor e voltar para a ficha dele é um caso em que a
 * confirmação nasce numa rota e é lida em outra.
 */
export interface Aviso {
  id: number
  tom: 'ok' | 'erro'
  texto: string
}

export const useAvisosStore = defineStore('avisos', () => {
  const lista = ref<Aviso[]>([])
  let proximoId = 1

  function empilhar(tom: Aviso['tom'], texto: string): void {
    const id = proximoId++
    lista.value = [...lista.value, { id, tom, texto }]

    // Erro fica mais tempo: ele costuma trazer instrução, e instrução precisa ser
    // lida. Sucesso é só confirmação, e some antes de virar estorvo.
    setTimeout(() => dispensar(id), tom === 'erro' ? 8000 : 3500)
  }

  function dispensar(id: number): void {
    lista.value = lista.value.filter((a) => a.id !== id)
  }

  return {
    lista,
    sucesso: (texto: string) => empilhar('ok', texto),
    falha: (texto: string) => empilhar('erro', texto),
    dispensar,
  }
})
